export default "__VITE_PUBLIC_ASSET__ce673bf7__"